'use strict';

angular.module('atex.dam').directive('previewTemplateField',
['$compile', function($compile) {
  return {
    restrict: 'E',

    scope: {
      field: '='
    },

    controller: function($scope) {
      if (typeof $scope.field !== 'undefined') {
        $scope.config = atex.onecms.ObjectUtils.getByPath($scope, 'field/dataBinding/config') || {};
        $scope.domainObject = atex.onecms.ObjectUtils.getByPath($scope, 'field/domainObject');
        $scope.domainObjects = atex.onecms.ObjectUtils.getByPath($scope, 'field/domainObjects') || {};
      }
    },

    link: function(scope, element, attrs) {
      if (typeof scope.field === 'undefined') {
        console.warn('No field information supplied to template field rendering, skipping...');
        return;
      }

      var widgetId = scope.field.widgetId;
      var baseUrl = scope.field.baseUrl;
      var dataBinding = scope.field.dataBinding;
      var directiveNameDashed = scope.field.widgetNameDashed;

      var hasLabel = typeof dataBinding.label !== 'undefined' && dataBinding.label.length > 0;

      var htmlOutput = '<div id="' + widgetId + '" class="form-group'+ (hasLabel ? '' : ' no-label') +'">';

      if (hasLabel) {
        htmlOutput += '<a class="control-label" data-toggle="collapse" href="#collapse' + widgetId + '"><label for="form-control-' + widgetId + '">{{\'' + dataBinding.label + '\'|translate}}</label></a>';
      }

      htmlOutput += '<div id="collapse' + widgetId + '" class="panel-collapse collapse in" x-' + directiveNameDashed + ' x-base-url="' + baseUrl + '" x-widget-id="' + widgetId + '" data-config="config" data-domain-object="domainObject" data-domain-objects="domainObjects"></div>';
      htmlOutput += '</div>';

      element.html(htmlOutput);
      element.addClass('template-field');

      $compile(element.contents())(scope);
    }
  };
}]);

angular.module('atex.dam').directive('damContentPreview',
['$rootScope', '$timeout', '$compile', '$q', '$location', 'PolopolyFSFileService',
  'TypeService', 'WidgetService', 'TemplateConfigurationService', 'Application', 'TemplateParsingService',

  function($rootScope, $timeout, $compile, $q, $location, PolopolyFSFileService,
           TypeService, WidgetService, TemplateConfigurationService, Application, TemplateParsingService) {
    var ID_PREFIX = 'atex.onecms.Widget-';

    var domainObjectService = atex.onecms.domain.DomainObjectService($q, PolopolyFSFileService);
    var factory = atex.onecms.domain.DomainObjectFactory($q, TypeService, PolopolyFSFileService, domainObjectService);

    var createId = function(prefix) {
      var idPrefix = (typeof prefix !== 'undefined') ? prefix + '-' : '';
      return idPrefix + Math.round(Math.random() * 10000000).toString(16).substring(0, 5).toUpperCase();
    };

    var initializeViewIds = function(layout) {
      (layout.views || []).forEach(function(view) {
        view.id = createId('view');
        initializeViewIds(view);
      });
    };

    var initializeLayoutFields = function(fieldBindings, layout, domainObject) {
      (layout.views || []).forEach(function(view) {
        var viewFields = [];

        (view.fields || []).forEach(function(viewField) {
          var field = _.find(fieldBindings, function(fieldBinding) {
            return fieldBinding.dataBinding.name === viewField;
          });

          if (typeof field !== 'undefined') {
            viewFields.push(instantiateField(field, domainObject));
          } else {
            console.warn("No data binding using the name '" + viewField + "' could be found, skipping...");
          }
        });

        view.fields = viewFields;

        initializeLayoutFields(fieldBindings, view, domainObject);
      });
    };

    var instantiateField = function(fieldBinding, domainObjectTree) {
      var widgetId = createId('widget');

      var fieldDomainObjects = {};

      if (typeof fieldBinding.dataBinding.domainObjects !== 'undefined') {
        var shortDomainObjectPaths = JSON.parse(JSON.stringify(fieldBinding.dataBinding.domainObjects));

        Object.keys(shortDomainObjectPaths).forEach(function(domainObjectKey) {
          shortDomainObjectPaths[domainObjectKey] = atex.onecms.ObjectUtils.expandShortPath(shortDomainObjectPaths[domainObjectKey]);
        });

        var domos = atex.onecms.DomainObjectUtils.getMultipleDomainObjectsByPath(domainObjectTree.getChild('aspects'), shortDomainObjectPaths);

        _.each(domos, function(domo, key) {
          fieldDomainObjects[key] = atex.onecms.DomainObjectUtils.getProxyFor(domo, widgetId);
        });
      }

      var field = JSON.parse(JSON.stringify(fieldBinding));

      field.widgetId = widgetId;
      field.domainObjects = fieldDomainObjects;

      return field;
    };

    var loadDataBinding = function(templateId, dataBinding) {
      if (typeof dataBinding.widget === 'undefined') {
        console.warn("No widget defined for field '" + (dataBinding.name || '[anonymous field]') + "', skipping...");
        return $q.when();
      }

      var bundleId = dataBinding.widget.split("/")[0];
      var widgetName = dataBinding.widget.split("/")[1] || dataBinding.widget;

      var widgetPromise = WidgetService.getWidget(widgetName, bundleId),
          baseUrlPromise = PolopolyFSFileService.getBaseUrl(ID_PREFIX + dataBinding.widget);

      // $q doesn't have .spread(), so this looks a bit off...
      return $q.all([widgetPromise, baseUrlPromise]).then(function(result) {
        var widget = result[0];
        var baseUrl = result[1];

        var globalConfig = dataBinding.globalConfig || widget.globalConfig || {};
        var configs = globalConfig.name || [];
        if (_.isString(configs)) {
          var name = configs;
          configs = [name];
        }
        var ignoreConfigErrors = globalConfig.ignoreErrors || false;
        var overrideLocal = globalConfig.overrideLocal || false;
        var injectSystemConfig = typeof globalConfig.injectSystemConfig !== 'undefined' ? globalConfig.injectSystemConfig : false;

        var widgetConfigPromises = [];

        // for each required config we will create a new promise.

        configs.map(function(configName) {
          widgetConfigPromises.push(TemplateConfigurationService.getWidgetConfiguration({
            id: configName,
            templateId: templateId,
            appName: Application.shortName
          }));
        });

        // we can inspect the configPromises directly (i.e. $$state is considered private)
        // so we must "then" the promises, since we may want to ignore errors and apply
        // only the successfull promises we will use $q.allSettled and inspect the results.

        return $q.allSettled(widgetConfigPromises).then(function(configPromisesResults) {
          var alertName = dataBinding.label || dataBinding.name || dataBinding.widget;
          var modified = false;
          var config = overrideLocal ? JSON.parse(JSON.stringify(dataBinding.config)) || {} : {};
          configPromisesResults.map(function(configResult) {
            if (configResult.state === 'fulfilled') {
              modified = true;
              var configResponseInfo = configResult.value.data || {};
              config = _.extend(config, configResponseInfo);
            } else {
              var error = configResult.reason;
              var fieldError = atex.onecms.error.Error({
                rootCause: error,
                cause: 'Error loading widget "' + alertName + '" configuration: ' + error.cause,
                origin: 'atex.onecms.ui.contentEditor',
                severity: atex.onecms.error.severities.CRITICAL
              });
              console.error("ERROR:", fieldError);
              if (!ignoreConfigErrors) {
                throw fieldError;
              }
            }
          });
          if (modified) {
            // apply the original configuration which may override the global one.
            //console.debug('current config for ' + alertName, JSON.parse(JSON.stringify(dataBinding.config || {})));
            if (!overrideLocal) {
              config = _.extend(config, dataBinding.config || {});
            }

            // finally apply the resulting configuration to the widget instance.
            //console.debug('applying new config for ' + alertName, config);
            dataBinding.config = config;
          }

          var directiveNameDashed = widget.directiveName.replace(/\W+/g, '-').replace(/([a-z\d])([A-Z])/g, '$1-$2').replace(/([A-Z])(?=[A-Z])/g, '$1-').toLowerCase();

          if (injectSystemConfig) {
            return TemplateConfigurationService.getSystemConfiguration().then(function(systemConfig) {
              var widgetConfig = dataBinding.config;
              if (widgetConfig && widgetConfig.system) {
                var fieldError = atex.onecms.error.Error({
                  cause: 'The system attribute is already present in the configuration',
                  origin: 'atex.onecms.ui.contentEditor',
                  severity: atex.onecms.error.severities.CRITICAL,
                  type: atex.onecms.error.types.INVALID_PARAMETERS
                });
                console.error("ERROR:", fieldError);
                if (!ignoreConfigErrors) {
                  throw fieldError;
                }
              } else {
                dataBinding.config = _.extend({}, dataBinding.config || {}, { system: systemConfig.data});
              }
              return {
                baseUrl: baseUrl,
                dataBinding: dataBinding,

                widgetNameDashed: directiveNameDashed
              };
            }, function(error) {
              // ignore 404 for the system config, so we will still support
              // up to polopoly 10.16.7 even if without the timezone conversion.
              if (error.rootCause && error.rootCause.status === 404) {
                return {
                  baseUrl: baseUrl,
                  dataBinding: dataBinding,

                  widgetNameDashed: directiveNameDashed
                };
              } else {
                throw error;
              }
            });
          } else {
            return {
              baseUrl: baseUrl,
              dataBinding: dataBinding,

              widgetNameDashed: directiveNameDashed
            };
          }
        });
      }, function(error) {
        var fieldError = atex.onecms.error.Error({
          rootCause: error,
          cause: 'Error loading widget "' + dataBinding.widget + '": ' + error.cause,
          origin: 'atex.onecms.ui.contentEditor',
          severity: atex.onecms.error.severities.CRITICAL
        });

        console.error("ERROR:", fieldError);
        return $q.reject(fieldError);
      });
    };
    
    return {
      transclude: true,
      restrict: 'E',

      scope: {
        article: '=',
        template: '=',

        loadCallback: '&',
        initCallback: '&',
        
        errorCallback: '&',

        updateActiveViewCallback: '&',
        isActiveViewCallback: '&',
      },

      controller: function($scope) {

        $scope.errorCallback = $scope.errorCallback() || _.noop;
        $scope.loadCallback = $scope.loadCallback() || _.noop;
        $scope.initCallback = $scope.initCallback() || _.noop;

        $scope.updateActiveViewCallback = $scope.updateActiveViewCallback(0);
        $scope.isActiveViewCallback = $scope.isActiveViewCallback(0);

        $scope.fields = [];
        $scope.layout = {};

        $scope.$on('$destroy', function() {
          $scope.destroyed = true;

          if (typeof $scope.topDomainObject !== 'undefined') {
            $scope.topDomainObject.destroy();
          }

          if (typeof $scope.errorFinalizer !== 'undefined') {
            $scope.errorFinalizer();
          }
        });
      },

      link: function(scope, element, attrs, ctrl, transclude) {
        scope._template = angular.copy(scope.template);
        scope.initCallback();

        var templateLayout = atex.onecms.ObjectUtils.getByPath(scope, 'template/layout') || {};
        scope.layout = JSON.parse(JSON.stringify(templateLayout));

        TemplateParsingService.filterLayoutFields(scope.layout).then(function() {
          initializeViewIds(scope.layout);
        }).then(function() {
          var domainObjectData = { aspects: _.extend({ contentData: { data: { _type: scope._template.type } } }, scope.article.data.aspects) };

          factory.fromData(domainObjectData, scope._template).then(function(domainObject) {
            scope.topDomainObject = domainObject;
            var promises = scope._template.dataBindings.map(function(dataBinding) {
              return loadDataBinding(scope._template.id, dataBinding);
            });

            return $q.all(promises).then(function(fieldBindings) {
              var filteredFieldBindings = _.filter(fieldBindings, function(fieldBinding) {
                return typeof fieldBinding !== 'undefined';
              });

              scope.fields = filteredFieldBindings.map(function(fieldBinding) {
                return instantiateField(fieldBinding, domainObject);
              });

              initializeLayoutFields(filteredFieldBindings, scope.layout, domainObject);

              transclude(scope, function(clone, scope) {
                element.empty().append(clone);
                element.addClass('content-editor');
              });

              scope.loadCallback();

              scope.errorFinalizer = domainObject.on('onecms:error', function(event, error) {
                scope.errorCallback(error);
              });
              
            });
          }).then(undefined, function(error) {
            var errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined') ?
              error.cause : 'Unknown error while initializing content preview!';

            var editorError = atex.onecms.error.Error({
              cause: errorMessage,
              rootCause: error,
              origin: 'atex.dam.contentPreview',
              severity: atex.onecms.error.severities.CRITICAL
            });

            console.error("Error while initializing content preview!", editorError);

            scope.errorCallback(editorError);
          });
        });
      }
    };
  }
]);
